import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import AddPhoneModal from "@/shared/components/channels/AddPhoneModal.vue";
import { createOrganisationCommunicationChannel } from "../../infrastructure/api/organisationApi";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationAddPhoneModal',
    props: /*@__PURE__*/ _mergeModels({
        organisationId: {},
        hasPrimaryPhone: { type: Boolean }
    }, {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["created"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const props = __props;
        const open = _useModel(__props, "modelValue");
        const emit = __emit;
        const ERROR_OVERRIDES = {
            'CommunicationChannel.Phone.Invalid': 'organisation.detail.addPhone.errors.phoneInvalid',
        };
        function submitPhone(payload) {
            return createOrganisationCommunicationChannel(props.organisationId, {
                type: "Phone",
                value: payload.value,
                isPrimary: payload.isPrimary,
                subType: payload.subType,
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AddPhoneModal, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                "has-primary-phone": __props.hasPrimaryPhone,
                "with-context": false,
                submit: submitPhone,
                "error-overrides": ERROR_OVERRIDES,
                "i18n-prefix": "organisation.detail.addPhone",
                onCreated: _cache[1] || (_cache[1] = ($event) => (emit('created')))
            }, null, 8 /* PROPS */, ["modelValue", "has-primary-phone"]));
        };
    }
});
